import { buildContactIdLookupHooks, buildStateValidationHook, mapCustomFieldsToDromoFields } from 'bundles/crm/imports/helpers';
import { getPropertyFields } from './fields';

import type { CustomField } from 'bundles/apex/custom_fields/types';
import type { Country } from '../types';

export const groupId = 'crm_properties';

const ownerHooks = buildContactIdLookupHooks(
  'Owner Contact ID',
  { idKey: 'ownerContactId', queryKey: 'ownerContact' },
);

export function getDromoImporterConfig(countries: Country[], customFields: CustomField[]) {
  return {
    bulkRowHooks: [ownerHooks.bulkRowHook, buildStateValidationHook(countries)],
    fields: [...getPropertyFields(countries), ...mapCustomFieldsToDromoFields(customFields)],
    groupId,
    importerOptions: {
      parser: 'Backoffice::Importer::Providers::Dromo::Parsers::Properties',
    },
    importerType: 'crm',
    stepHooks: [ownerHooks.stepHook],
    title: 'Properties',
  };
}
